import Icon from "@material-ui/icons/Person";
import HolidayCreate from "./HolidayCreate";
import HolidayEdit from "./HolidayEdit";

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  name: "holidays",
  edit: HolidayEdit,
  create: HolidayCreate,
  icon: Icon,
};
